import React from 'react';
import PropTypes from 'prop-types';

import SortIcon from '../../common/Icons/Sort.svg';
import SortAscIcon from '../../common/Icons/Sort-Asc.svg';
import SortDescIcon from '../../common/Icons/Sort-Desc.svg';

const HeaderSortDisplay = ({ styles }) => (
    <>
        <img src={ SortIcon } alt="sortable" className={ `${styles.sortIcon} ${styles.sortingIcon}` } />
        <img src={ SortAscIcon } alt="sortable" className={ `${styles.sortAscIcon} ${styles.sortingIcon}` } />
        <img src={ SortDescIcon } alt="sortable" className={ `${styles.sortDescIcon} ${styles.sortingIcon}` } />
    </>
);
HeaderSortDisplay.propTypes = {
    styles: PropTypes.shape({
        sortIcon: PropTypes.string,
        sortingIcon: PropTypes.string,
        sortAscIcon: PropTypes.string,
        sortDescIcon: PropTypes.string
    }),
};

HeaderSortDisplay.defaultProps = {
    styles: {}
};
export default HeaderSortDisplay;
